export const GITHUB_URL = 'https://github.com/Archkrull';
export const LINKEDIN_URL = 'https://www.linkedin.com/in/neah-rockstroh-a789a01a6/';
export const STACKOVERFLOW_URL = 'https://stackoverflow.com/users/19463540/neah';